import { useSelector } from "react-redux";
import { Badge, Button, Card, Col, Form, ListGroup, ListGroupItem, Row, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PlanBlock = ({ index, plan, previousPlan }) => {
  const navigate = useNavigate();

  // Visual style per technical plan name
  const colors = {
    // Billplus core
    free: "secondary",
    free_yearly: "secondary",
    starter_mobile: "info",
    starter_mobile_yearly: "info",
    starter: "primary",
    starter_yearly: "primary",
    premium: "warning",
    premium_yearly: "warning",
    enterprise: "success",
    enterprise_yearly: "success",

    // Fitplus CE
    free_ce: "secondary",
    free_ce_yearly: "secondary",
    plus_ce: "info",
    plus_ce_yearly: "info",
    pro_ce: "primary",
    pro_ce_yearly: "primary",
    max_ce: "success",
    max_ce_yearly: "success",

    // Legacy / fallback
    standard: "info",
    standard_yearly: "info",
    pro_club_edition: "success",
    pro_club_edition_yearly: "success",
  };

  const colorKey = colors[plan?.name] || "primary";

  const { currentPlan } = useSelector((state) => state.plans);
  const isCurrentPlan = currentPlan?.plan?.id === plan?.id;

  const previousFeatures = previousPlan?.features?.map((f) => f.name) || [];
  const newFeatures = plan?.features?.filter((feature) => !previousFeatures.includes(feature.name)) || [];

  const targetDate = new Date(currentPlan?.subscription?.expires_at);
  const currentDate = new Date();
  const diffTime = targetDate - currentDate;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));


  return (
    <Col md={4} className="mb-4 mt-3">
      <Card
        className="h-100 shadow-sm border-0"
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
        }}
      >
        {isCurrentPlan && <div class="ribbon-wrapper-green-plan">
          <div class="ribbon-green-plan">Active</div>
        </div>}
        <Card.Header className="p-0 border-0">
          <div
            className={`bg-${colorKey} w-100`}
            style={{ height: "6px" }}
          />
        </Card.Header>
        <Card.Body className="px-4 pb-4 pt-3">
          <Row>
            <Col lg={12} xs={12} md={12}>
              <h2 className="mb-1" style={{ fontSize: "20px", fontWeight: 700 }}>
                {plan?.label}
              </h2>
              {plan?.tagline && (
                <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                  {plan.tagline}
                </p>
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col lg={12} xs={12} md={12}>
              <div className="d-flex align-items-center justify-content-between">
                <span
                  className={`px-3 py-2 rounded-pill bg-${colorKey} bg-opacity-10 text-${colorKey}`}
                  style={{ fontSize: "18px", fontWeight: 600 }}
                >
                  ₹&nbsp;{plan?.price}
                  {!plan?.label?.includes("Free") && (
                    <span className="text-muted ms-1" style={{ fontSize: "13px" }}>
                      / {plan?.period === "monthly" ? "month" : "year"}
                    </span>
                  )}
                </span>
              </div>
            </Col>
          </Row>

          {plan?.label === "Free" ? null : currentPlan?.plan?.is_trial == 1 ||
            currentPlan?.plan?.label == "Free" ? (
              <Row className="mt-3">
                <Col lg={12} xs={12} md={12}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={() => navigate("/plan/create-order/?selected=" + plan.id)}
                  >
                    Select plan
                  </Button>
                </Col>
              </Row>
            ) : (
              <>
                {isCurrentPlan && (
                  <Row className="mt-3">
                    <Col lg={12} xs={12} md={12}>
                      {diffDays !== 0 && (
                        <Form.Label className="text-muted" style={{ fontSize: "13px" }}>
                          Your {currentPlan?.plan?.is_trial === 1 ? "trial" : "plan"} ends
                          in {diffDays} days.
                        </Form.Label>
                      )}
                      {diffDays === 0 && (
                        <Form.Label className="text-muted" style={{ fontSize: "13px" }}>
                          Your {currentPlan?.plan?.is_trial === 1 ? "trial" : "plan"} ends today.
                          Upgrade to continue enjoying the benefits.
                        </Form.Label>
                      )}
                    </Col>
                  </Row>
                )}
              </>
            )}

          <Row className="mt-4">
            <Col lg={12} xs={12} md={12}>
              {plan?.label === "Free" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Features</h4>
              )}
              {plan?.label === "Starter" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Free, plus</h4>
              )}
              {plan?.label === "Premium" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Starter, plus</h4>
              )}
              {plan?.label === "Enterprise" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Premium, plus</h4>
              )}
              {plan?.label === "Plus CE" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Free CE, plus</h4>
              )}
              {plan?.label === "Pro CE" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Plus CE, plus</h4>
              )}
              {plan?.label === "Max CE" && (
                <h4 style={{ fontWeight: 500, fontSize: "16px" }}>Everything in Pro CE, plus</h4>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={12} xs={12} md={12}>
              <ListGroup variant="flush" className="pt-1">
                {newFeatures?.map((feature, idx) => (
                  <ListGroupItem
                    className="py-2 px-0 border-0"
                    style={{ textTransform: "capitalize", fontSize: "14px" }}
                    key={idx}
                  >
                    <span className="me-2 text-success">✔</span>
                    {feature?.name.replace("_", " ")}
                  </ListGroupItem>
                ))}
              </ListGroup>

            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default PlanBlock;
